export default __webpack_public_path__ + "static/media/avatar.432c1c99.jpg";